<template>
	<div>
		<main role="main">
			<div class="content-safe-space">
				<slot/>
			</div>
		</main>
		<Modal/>
	</div>
</template>
<script>
import watchesWindowResizeEvent from "../../../mixins/watchesWindowResizeEvent";

export default {
	mixins: [
		watchesWindowResizeEvent,
	],

	data() {
		return {
			expanded: false,
			showNav: false,
			timeout: null,
			routerViewKey: 0,
		};
	},
};
</script>
